class PushCard extends window.BAO.CustomElement() {
  setupListeners () {
    this.handleSelect = this.handleSelect.bind(this)

    if (this?.els?.select?.exists) {
      this.listeners.add(this.els.select.element, `change`, this.handleSelect)
    }
  }

  handleSelect () {
    if (this?.els?.button?.exists) {
      this.els.button.element.click()
    }
  }
}

if (!customElements.get('push-card')) {
  customElements.define('push-card', PushCard)
}
